const faqs = [
    {
        id: 1,
        heading: 'What are the different roofing materials available?',
        content: 'Explore various roofing materials such as asphalt shingles, metal roofing, clay tiles, and flat roofing systems, along with their durability, aesthetic appeal, and suitability for different climates.',
    },
    {
        id: 2,
        heading: 'How is the roof installation process carried out?',
        content: 'Learn about the step-by-step roof installation process, including removing old roofing, preparing the roof deck, installing underlayment, and securing the new roofing materials to ensure long-lasting protection.',
    },
    {
        id: 3,
        heading: 'What types of roof repair services do you offer?',
        content: 'Discover the roof repair services available, from fixing leaks and replacing damaged shingles to addressing issues with flashing, gutters, and ventilation systems, to keep your roof in top condition.',
    },
    {
        id: 4,
        heading: 'How can I maintain the quality of my roof?',
        content: 'Find out effective roof maintenance tips, including regular inspections, cleaning debris, checking for signs of wear, and preventive measures to extend the life of your roof and avoid costly repairs.',
    },
    {
        id: 5,
        heading: 'How do I choose the right roof for my home?',
        content: 'Get guidance on choosing the right roof for your home by considering factors such as your budget, climate, architectural style, and the specific advantages of different roofing materials.',
    },
];

export default faqs;